module.exports = __webpack_public_path__ + "img/Profile Icon.a5353bc2.svg";